/* AC Panier Premium — progressive enhancement, native Dawn cart stays authoritative. */
(() => {
  if (window.__acCartPremiumInstalled) return;
  window.__acCartPremiumInstalled = true;
  let busy = false, queued = false;
  const cfg = () => document.querySelector('[id^="ac-cart-config-"]');
  const icon = (name) => {
    const paths = {
      lock:'<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
      arrow:'<path d="M4 12h16m-7-7 7 7-7 7"/>',
      bag:'<path d="M5 8h14l1 13H4L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/>'
    };
    return paths[name] ? `<span class="ac-cart-cta-icon" aria-hidden="true"><svg viewBox="0 0 24 24">${paths[name]}</svg></span>` : '';
  };
  function money(cents){
    const format = window.Shopify?.currency?.active || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:format}).format(cents/100); }
    catch {return (cents/100).toFixed(2)+' €';}
  }
  function setText(el, text){ if(el && el.textContent !== text) el.textContent=text; }
  // Variants already present in the cart must never be recommended as upsells.
  const pendingUpsellVariants=new Set();
  let knownCartVariants=null;
  function cartVariants(){
    const config=cfg();
    const visible=document.querySelectorAll('cart-drawer #CartDrawer-CartItems .cart-item input[data-quantity-variant-id]');
    if(visible.length)return new Set([...visible].map(el=>String(el.dataset.quantityVariantId)).filter(Boolean));
    if(knownCartVariants)return new Set(knownCartVariants);
    return new Set((config?.dataset.cartVariantIds||'').split(',').filter(Boolean));
  }
  function rememberCartVariants(cart){
    if(!Array.isArray(cart?.items))return;
    knownCartVariants=new Set(cart.items.map(item=>String(item.variant_id||item.id)).filter(Boolean));
    pendingUpsellVariants.clear();
  }
  function decorate(){
    const config=cfg(), drawer=document.querySelector('cart-drawer'), inner=drawer?.querySelector('.drawer__inner');
    if(!config||!drawer||!inner) return;
    document.body.classList.add('ac-cart-enabled');
    const emptyState=drawer.classList.contains('is-empty')||!inner.querySelector('#CartDrawer-CartItems .cart-item');
    drawer.classList.toggle('ac-cart-actually-empty',emptyState);
    setText(inner.querySelector('[data-ac-empty-message]'),config.dataset.emptyText||'Votre panier est vide');
    setText(inner.querySelector('[data-ac-empty-cta]'),config.dataset.emptyCta||'Continuer mes achats');
    const emptyLink=inner.querySelector('a[data-ac-empty-cta]');
    if(emptyLink)emptyLink.href=config.dataset.emptyCtaUrl||'/collections/all';
    for(const key of ['green','cream','text','border','radius','empty-cta-bg','empty-cta-color','drawer-width','upsell-width','progress-bg','progress-fill','cta-bg','cta-color','heading-size','product-size','image-size','item-gap','footer-padding','cta-height','cta-font','upsell-bg','upsell-button','upsell-image-size','upsell-heading-size','shipping-bg','shipping-padding','progress-height','shipping-font','payment-height','muted']) {
      const value=config.style.getPropertyValue('--ac-'+key);
      if(value) drawer.style.setProperty('--ac-'+key,value);
    }
    let main=inner.querySelector(':scope > .ac-cart-main');
    if(!main){
      main=document.createElement('div');main.className='ac-cart-main';
      const elements=[...inner.children];elements.forEach(el=>main.appendChild(el));inner.appendChild(main);
    }
    // Conserver les composants Dawn pour les quantités et suppressions ;
    // seule la position visuelle de la poubelle change.
    main.querySelectorAll('.cart-item__quantity-wrapper').forEach(wrapper=>{
      const remove=wrapper.querySelector('cart-remove-button');
      if(remove && wrapper.firstElementChild!==remove)wrapper.prepend(remove);
    });
    // Upsell ajouté : supprimer uniquement les contrôles de quantité visuels,
    // conserver le bouton natif de suppression Dawn.
    const upsellVariants=new Set([...config.querySelectorAll('.ac-cart-upsell-source > .ac-cart-upsell')].map(el=>String(el.dataset.variant)));
    main.querySelectorAll('.cart-item').forEach(item=>{
      const variantInput=item.querySelector('input[data-quantity-variant-id]');
      item.classList.toggle('ac-cart-upsell-line',!!variantInput&&upsellVariants.has(String(variantInput.dataset.quantityVariantId)));
    });
    const heading=main.querySelector('[data-ac-cart-title]');setText(heading,config.dataset.title||'VOTRE PANIER');
    const count=main.querySelector('[data-ac-cart-count]');
    if(count){const qty=[...main.querySelectorAll('input.quantity__input')].reduce((sum,i)=>sum+(Number(i.value)||0),0);setText(count,qty>0?String(qty):'');count.hidden=qty===0;}
    setText(main.querySelector('[data-ac-cart-total-label]'),config.dataset.totalLabel||'TOTAL');
    const cta=main.querySelector('.cart__checkout-button');
    if(cta){const text=config.dataset.cta||'PROCÉDER AU PAIEMENT', svg=icon(config.dataset.ctaIcon);const markup=config.dataset.ctaSide==='right'?`<span data-ac-cart-cta></span>${svg}`:`${svg}<span data-ac-cart-cta></span>`;
      if(cta.dataset.acMarkup!==markup){cta.innerHTML=markup;cta.dataset.acMarkup=markup;}setText(cta.querySelector('[data-ac-cart-cta]'),text);
    }
    const footer=main.querySelector(':scope > .drawer__footer');
    if(footer){let trust=footer.querySelector('.ac-cart-trust-badges');if(config.dataset.showTrust==='true'){if(!trust){trust=document.createElement('div');trust.className='ac-cart-trust-badges';}trust.replaceChildren();for(const t of [config.dataset.trustOne,config.dataset.trustTwo]){const badge=document.createElement('span');badge.className='ac-cart-trust-badge';badge.textContent=t||'';trust.append(badge);}footer.append(trust);}else trust?.remove();}
    if(footer){let payments=footer.querySelector('.ac-cart-payment-icons');if(config.dataset.showPayments==='true'){
      if(!payments){payments=document.createElement('div');payments.className='ac-cart-payment-icons';footer.appendChild(payments);}
      const source=config.querySelector('.ac-cart-payments-source');
      if(source && (payments.childElementCount===0 || payments.dataset.sourceVersion!==source.innerHTML.length.toString())){
        payments.innerHTML=source.innerHTML;
        payments.dataset.sourceVersion=source.innerHTML.length.toString();
      }
    } else payments?.remove();const trust=footer.querySelector('.ac-cart-trust-badges');const pay=footer.querySelector('.ac-cart-payment-icons');if(trust&&pay)footer.insertBefore(trust,pay);}
    let shipping=main.querySelector(':scope > .ac-cart-shipping');
    if(config.dataset.showShipping==='true'){
      if(!shipping){shipping=document.createElement('div');shipping.className='ac-cart-shipping';shipping.innerHTML="<div class=\"ac-cart-shipping__text\" aria-live=\"polite\"></div><div class=\"ac-cart-shipping__progress\"><div class=\"ac-cart-shipping__track\"><div class=\"ac-cart-shipping__fill\"></div></div><span class=\"ac-cart-shipping__marker\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" fill=\"currentColor\"><path d=\"M195-195q-35-35-35-85H60l18-80h113q17-19 40-29.5t49-10.5q26 0 49 10.5t40 29.5h167l84-360H182l4-17q6-28 27.5-45.5T264-800h456l-37 160h117l120 160-40 200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H400q0 50-35 85t-85 35q-50 0-85-35Zm442-245h193l4-21-74-99h-95l-28 120Zm-19-273 2-7-84 360 2-7 34-146 46-200ZM20-427l20-80h220l-20 80H20Zm80-146 20-80h260l-20 80H100Zm180 333q17 0 28.5-11.5T320-280q0-17-11.5-28.5T280-320q-17 0-28.5 11.5T240-280q0 17 11.5 28.5T280-240Zm400 0q17 0 28.5-11.5T720-280q0-17-11.5-28.5T680-320q-17 0-28.5 11.5T640-280q0 17 11.5 28.5T680-240Z\"/></svg></span></div>";main.querySelector(':scope > cart-drawer-items')?.before(shipping);}
    }else shipping?.remove();
    const existing=cartVariants();
    const items=[...config.querySelectorAll('.ac-cart-upsell-source > .ac-cart-upsell')]
      .filter(el=>!pendingUpsellVariants.has(String(el.dataset.variant)));
    const cartHasItems=!!main.querySelector('#CartDrawer-CartItems .cart-item, cart-drawer-items .cart-item');
    const enabled=config.dataset.showUpsells==='true'&&items.length>0&&cartHasItems;
    drawer.classList.toggle('ac-cart-has-upsells',enabled);
    let panel=inner.querySelector(':scope > .ac-cart-upsells-panel');
    let mobile=main.querySelector(':scope > .ac-cart-upsells-mobile');
    if(enabled){
      const signature=items.map(el=>el.dataset.variant+'-'+el.querySelector('img')?.src+'-'+el.querySelector('.ac-cart-upsell__name')?.textContent).join(',')+'|'+config.dataset.upsellTitle;
      if(!panel){panel=document.createElement('aside');panel.className='ac-cart-upsells-panel';inner.appendChild(panel);}
      if(panel.dataset.signature!==signature){panel.replaceChildren();const title=document.createElement('h3');title.textContent=config.dataset.upsellTitle;panel.append(title,...items.map(el=>el.cloneNode(true)));panel.dataset.signature=signature;}panel.classList.toggle('ac-cart-single-upsell',items.length===1);
      if(!mobile){mobile=document.createElement('aside');mobile.className='ac-cart-upsells-mobile';const title=document.createElement('h3');const track=document.createElement('div');track.className='ac-cart-upsells-mobile__track';mobile.append(title,track);footer?.before(mobile);}
      if(mobile.dataset.signature!==signature){setText(mobile.querySelector('h3'),config.dataset.upsellTitle);mobile.querySelector('.ac-cart-upsells-mobile__track').replaceChildren(...items.map(el=>el.cloneNode(true)));mobile.dataset.signature=signature;}mobile.classList.toggle('ac-cart-single-upsell',items.length===1);
    } else {panel?.remove();mobile?.remove();}
  }
  // Un seul propriétaire du rafraîchissement après ajout.
  // Ne jamais injecter la section add.js puis la remplacer une deuxième fois.
  let acSyncSequence = 0;
  let cartCache = null;
  let cartCacheAt = 0;
  function updateCartCounters(quantity){
    if(!Number.isFinite(quantity))return;
    const count=Math.max(0,Math.trunc(quantity));
    document.querySelectorAll('[data-ac-cart-count]').forEach(el=>{
      setText(el,count?String(count):'');el.hidden=count===0;
    });
    document.querySelectorAll('[data-ac-cart-trigger]').forEach(trigger=>{
      let badge=trigger.querySelector('.ac-header__count');
      if(!badge&&count){badge=document.createElement('span');badge.className='ac-header__count';trigger.appendChild(badge);}
      if(badge){setText(badge,count?String(count):'');badge.hidden=count===0;}
    });
  }
  function cacheCart(cart){
    if(cart && typeof cart.total_price==='number'){
      cartCache=cart;cartCacheAt=Date.now();updateCartCounters(cart.item_count);rememberCartVariants(cart);
      updateShippingFromCart(cart);
    }
  }
  function updateShippingFromCart(cart){
    const config=cfg(),target=document.querySelector('cart-drawer .ac-cart-shipping');
    if(!config||!target||!cart)return;
    const drawer=document.querySelector('cart-drawer');
    const empty=cart.item_count===0;
    drawer?.classList.toggle('ac-cart-actually-empty',empty);
    if(empty){drawer?.classList.remove('ac-cart-has-upsells');drawer?.querySelector('.ac-cart-upsells-panel')?.remove();drawer?.querySelector('.ac-cart-upsells-mobile')?.remove();}
    const threshold=Number(config.dataset.threshold)||6000;
    const remaining=Math.max(0,threshold-cart.total_price);
    const ratio=Math.min(100,Math.max(0,cart.total_price/threshold*100));
    setText(target.querySelector('.ac-cart-shipping__text'),remaining>0?(config.dataset.shippingBefore||'Encore %amount% pour la livraison offerte').replace(/%amount%/g,money(remaining)):config.dataset.shippingAfter||'Livraison offerte !');
    target.style.setProperty('--ac-shipping-ratio',ratio+'%');
    target.querySelector('.ac-cart-shipping__fill')?.style.setProperty('width',ratio+'%','important');
    target.classList.toggle('ac-cart-shipping--complete',remaining===0);
    const progress=target.querySelector('.ac-cart-shipping__progress');
    progress?.setAttribute('role','progressbar');
    progress?.setAttribute('aria-valuenow',String(Math.round(ratio)));
    progress?.setAttribute('aria-valuemin','0');
    progress?.setAttribute('aria-valuemax','100');
  }
  function drawerMarkup(html){
    if(!html)return null;
    const parsed=new DOMParser().parseFromString(html,'text/html');
    return parsed.querySelector('#CartDrawer');
  }
  function hasExpectedItems(element,count){
    return !!element && (count===0 || !!element.querySelector('#CartDrawer-CartItems .cart-item'));
  }
  async function syncCartAfterAdd(state){
    const seq=++acSyncSequence;
    const drawer=document.querySelector('cart-drawer');
    if(!drawer)return;
    const root=window.Shopify?.routes?.root||'/';
    try{
      let fresh=drawerMarkup(state?.sections?.['cart-drawer']);
      let cart=null;
      // Use Shopify's response immediately when it includes real product rows.
      // Avoid the previous cart.js -> cart HTML sequential network waterfall.
      if(!fresh || !fresh.querySelector('#CartDrawer-CartItems .cart-item')){
        const response=await fetch(root+'cart?section_id=cart-drawer',{credentials:'same-origin',cache:'no-store'});
        if(!response.ok)throw Error('cart-drawer HTTP '+response.status);
        fresh=drawerMarkup(await response.text());
      }
      if(seq!==acSyncSequence)return;
      if(!fresh || !fresh.querySelector('#CartDrawer-CartItems .cart-item')){
        // One delayed retry for eventual consistency; never erase visible items.
        await new Promise(resolve=>setTimeout(resolve,180));
        const retry=await fetch(root+'cart?section_id=cart-drawer',{credentials:'same-origin',cache:'no-store'});
        if(!retry.ok)throw Error('cart-drawer retry HTTP '+retry.status);
        fresh=drawerMarkup(await retry.text());
      }
      if(seq!==acSyncSequence)return;
      if(!fresh || !fresh.querySelector('#CartDrawer-CartItems .cart-item'))throw Error('Cart response has no product rows');
      const current=drawer.querySelector('#CartDrawer');
      if(!current)throw Error('Drawer root missing');
      current.replaceWith(fresh);
      knownCartVariants=new Set([...fresh.querySelectorAll('input[data-quantity-variant-id]')].map(input=>String(input.dataset.quantityVariantId)).filter(Boolean));
      pendingUpsellVariants.clear();
      drawer.classList.remove('is-empty','ac-cart-actually-empty');
      fresh.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      fresh.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
      decorate();
      updateCartCounters([...fresh.querySelectorAll('input.quantity__input')].reduce((sum,input)=>sum+(Number(input.value)||0),0));
      drawer._allowAddToCartOpen = true;
      drawer.open();
      // The cart JSON request is independent and does not block displaying items.
      scheduleProgress();
    }catch(error){
      console.error('AC Panier Premium: synchronisation',error);
      drawer._allowAddToCartOpen = true;
      drawer.open();
    }
  }
  function installCartSync(){
    const drawer=document.querySelector('cart-drawer');
    if(!drawer||drawer.dataset.acSyncPatched)return;
    drawer.dataset.acSyncPatched='true';
    drawer.renderContents=function(state){
      // La section produit déclenche une seule synchronisation autoritaire.
      // Dawn ne doit plus injecter une deuxième réponse partielle obsolète.
      return syncCartAfterAdd(state);
    };
  }
  let fetchToken=0;
  async function refreshProgress(){
    const config=cfg(),target=document.querySelector('cart-drawer .ac-cart-shipping');
    if(!config||!target)return;
    if(cartCache && Date.now()-cartCacheAt<900){updateShippingFromCart(cartCache);return;}
    const token=++fetchToken;
    try{
      const base=window.Shopify?.routes?.root||'/';
      const response=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw Error('Cart unavailable');
      const cart=await response.json();
      if(token!==fetchToken||!target.isConnected)return;
      cacheCart(cart);
      if(cart.item_count>0 && !document.querySelector('cart-drawer.ac-cart-has-upsells'))schedule();
    }catch(error){console.warn('AC Panier Premium: progression indisponible',error);}
  }
  // Dawn already receives the complete cart after a quantity change.
  // Reuse that result rather than downloading cart.js again.
  document.addEventListener('ac:cart-updated',event=>{
    const cart=event.detail;
    if(!cart)return;
    cacheCart(cart);
    clearTimeout(progressTimer);
    schedule();
  });
  function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;decorate();});}
  let progressTimer;
  function scheduleProgress(){clearTimeout(progressTimer);progressTimer=setTimeout(refreshProgress,45);}
  document.addEventListener('click',async e=>{
    const add=e.target.closest('[data-ac-upsell-add]');if(!add||busy)return;
    e.preventDefault();const card=add.closest('[data-variant]');if(!card)return;
    busy=true;add.disabled=true;add.setAttribute('aria-busy','true');
    try{const root=window.Shopify?.routes?.root||'/';const resp=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({id:Number(card.dataset.variant),quantity:1,sections:['cart-drawer'],sections_url:location.pathname})});
      const data=await resp.json();if(!resp.ok)throw Error(data.description||'Ajout impossible');
      cartCache=null;
      pendingUpsellVariants.add(String(card.dataset.variant));
      // Hide the added recommendation immediately in both desktop and mobile.
      document.querySelectorAll('cart-drawer .ac-cart-upsell[data-variant]').forEach(el=>{
        if(el.dataset.variant===card.dataset.variant)el.remove();
      });
      schedule();
      const drawer=document.querySelector('cart-drawer');if(data.sections?.['cart-drawer']&&drawer?.renderContents){drawer.renderContents(data);schedule();scheduleProgress();}else location.assign(root+'cart');
    }catch(err){pendingUpsellVariants.delete(String(card.dataset.variant));schedule();alert(err.message||'Impossible d’ajouter ce produit au panier.');}
    finally{busy=false;add.disabled=false;add.removeAttribute('aria-busy');}
  });
  // Défilement direct à la souris, même en partant d'une image ou d'un lien.
  // Sur écran tactile, conserver l'inertie native du navigateur.
  let drag=null, suppressClickUntil=0;
  document.addEventListener('pointerdown',event=>{
    if(event.pointerType==='touch'||event.button!==0||event.target.closest('[data-ac-upsell-add]'))return;
    const track=event.target.closest('.ac-cart-upsells-mobile__track');
    if(!track||track.scrollWidth<=track.clientWidth+2)return;
    drag={track,id:event.pointerId,startX:event.clientX,startScroll:track.scrollLeft,lastX:event.clientX,lastTime:performance.now(),velocity:0,moved:false};
    track.classList.add('ac-cart-upsells--dragging');
    try{track.setPointerCapture(event.pointerId)}catch(e){}
  });
  document.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.id)return;
    const dx=event.clientX-drag.startX,now=performance.now();
    if(Math.abs(dx)>3)drag.moved=true;
    drag.velocity=(event.clientX-drag.lastX)/Math.max(1,now-drag.lastTime);
    drag.lastX=event.clientX;drag.lastTime=now;
    if(drag.moved){drag.track.scrollLeft=drag.startScroll-dx;event.preventDefault();}
  },{passive:false});
  function finishUpsellDrag(event){
    if(!drag||(event&&event.pointerId!==drag.id))return;
    const d=drag;drag=null;
    d.track.classList.remove('ac-cart-upsells--dragging');
    if(d.moved){
      suppressClickUntil=Date.now()+400;
      const impulse=Math.max(-1.4,Math.min(1.4,d.velocity))*150;
      if(Math.abs(impulse)>10)d.track.scrollBy({left:-impulse,behavior:'smooth'});
    }
    try{d.track.releasePointerCapture(d.id)}catch(e){}
  }
  document.addEventListener('pointerup',finishUpsellDrag);
  document.addEventListener('pointercancel',finishUpsellDrag);
  document.addEventListener('click',event=>{
    if(Date.now()<suppressClickUntil&&event.target.closest('.ac-cart-upsells-mobile__track')){
      event.preventDefault();event.stopImmediatePropagation();
    }
  },true);
  document.addEventListener('dragstart',event=>{
    if(event.target.closest('.ac-cart-upsells-mobile__track'))event.preventDefault();
  });
  const observer=new MutationObserver(records=>{
    if(records.some(r=>r.target.closest?.('cart-drawer') && (r.target.matches?.('.drawer__inner,.drawer__contents,.cart-drawer')||r.target.closest?.('cart-drawer-items')))){
      schedule();scheduleProgress();
    }
  });
  function init(){if(!cfg())return;installCartSync();schedule();scheduleProgress();const drawer=document.querySelector('cart-drawer');if(drawer)observer.observe(drawer,{subtree:true,childList:true});
    if(window.Shopify?.designMode&&cfg().dataset.preview==='true')setTimeout(()=>drawer?.open(),350);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',()=>{schedule();scheduleProgress();});
})();
